/**
 * AWS Amplify Configuration
 * Configures Amplify with Cognito User Pool credentials
 */

import { Amplify } from 'aws-amplify';

// Get configuration from environment variables
// Priority: .env.local > .env > default values
const amplifyConfig = {
  Auth: {
    Cognito: {
      // Use Terraform-created User Pool (pz-digital-users)
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'me-central-1_Nj7HrD48Y',
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '1l4qi2hdv3tourmgjo287pugkq',
      region: process.env.REACT_APP_AWS_REGION || 'me-central-1',
      loginWith: {
        email: true,
        username: true,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
    },
  },
};

// Log configuration (without sensitive data)
console.log('🔧 Amplify Configuration:', {
  userPoolId: amplifyConfig.Auth.Cognito.userPoolId,
  clientId: amplifyConfig.Auth.Cognito.userPoolClientId,
  region: amplifyConfig.Auth.Cognito.region,
  loginWith: amplifyConfig.Auth.Cognito.loginWith,
});

// Configure Amplify
try {
  Amplify.configure(amplifyConfig);
  console.log('✅ Amplify configured successfully');
} catch (error) {
  console.error('❌ Amplify configuration error:', error);
}

export default Amplify;






